import { buildListParams, type DataGridQuery, type PageRequest } from "@nymbl/nos2-rules";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { jobKeys } from "@/lib/query";
import { getJson } from "@/lib/time/api-client";
import {
  type JobRunRow,
  type JobView,
  jobRunsPageSchema,
  jobsResponseSchema,
} from "@/schemas/jobs";

export type { JobRunRow, JobView };

/** Refreshed each minute: the runner works on the minute, and this page is watched. */
const REFRESH_MS = 60_000;

/** Settings, Jobs: every job with its mode, last run and next run. */
export function useJobs() {
  return useQuery({
    queryKey: jobKeys.list,
    queryFn: async () => jobsResponseSchema.parse(await getJson("/api/admin/jobs")),
    refetchInterval: REFRESH_MS,
  });
}

/** The run history, a page at a time; the server sorts, filters and pages it. */
export function useJobRuns(query: DataGridQuery, pageRequest: PageRequest) {
  return useQuery({
    queryKey: [...jobKeys.runs(query), pageRequest] as const,
    queryFn: async () =>
      jobRunsPageSchema.parse(
        await getJson(`/api/admin/jobs/runs?${buildListParams(query, pageRequest)}`),
      ),
    placeholderData: keepPreviousData,
    refetchInterval: REFRESH_MS,
  });
}
